const EfiModel = ({ modelInfo, hideTitle = false, hideDescription = false }) => {
  return (
    <div className="bg-[#fff]">
      <div className="custom-container sm:pt-[63px] pt-[40px] ">
        {!hideTitle && modelInfo.title}
        {!hideDescription && (
          <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] mt-[40px]">
            {modelInfo.dec}
          </div>
        )}
      </div>
    </div>
  );
};
export default EfiModel;
